import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomIconGoogleColors = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path
                d="M20.3 10.2273C20.3 9.51822 20.2364 8.83642 20.1182 8.18182H10.7V12.05H16.0818C15.85 13.3 15.1455 14.3591 14.0864 15.0682V17.5773H17.3182C19.2091 15.8364 20.3 13.2727 20.3 10.2273Z"
                fill="#4285F4"
            />
            <path
                d="M10.7 20C13.4 20 15.6636 19.1045 17.3181 17.5773L14.0863 15.0682C13.1909 15.6682 12.0454 16.0227 10.7 16.0227C8.09537 16.0227 5.89087 14.2636 5.10447 11.9H1.76357V14.4909C3.40907 17.7591 6.79087 20 10.7 20Z"
                fill="#34A853"
            />
            <path
                d="M5.1045 11.9C4.9045 11.3 4.7909 10.6591 4.7909 9.99999C4.7909 9.34089 4.9045 8.69999 5.1045 8.09999V5.50909H1.7636C1.0864 6.85909 0.699997 8.38639 0.699997 9.99999C0.699997 11.6136 1.0864 13.1409 1.7636 14.4909L5.1045 11.9Z"
                fill="#FBBC04"
            />
            <path
                d="M10.7 3.9773C12.1681 3.9773 13.4863 4.4818 14.5227 5.4727L17.3909 2.6045C15.6591 0.9909 13.3954 0 10.7 0C6.79087 0 3.40907 2.2409 1.76357 5.5091L5.10447 8.1C5.89087 5.7364 8.09537 3.9773 10.7 3.9773Z"
                fill="#E94235"
            />
        </svg>
    </SvgIcon>
);
